export default __webpack_public_path__ + "static/media/blog-hero.5c9f3fca.jpg";